import { LettersImage } from '@approvalmax/ui';
import { Flex, Progress, Text } from '@approvalmax/ui/src/components';
import { hooks } from '@approvalmax/utils';
import * as Sentry from '@sentry/browser';
import { domain } from 'modules/data';
import { memo, useEffect } from 'react';
import { useDispatch } from 'react-redux';

import { verifyEmail } from '../../actions';
import { messages } from './Content.messages';

export const Content = memo(() => {
    const dispatch = useDispatch();

    const [email] = hooks.useQueryParam('email');
    const [code] = hooks.useQueryParam('code');
    const [postAction] = hooks.useQueryParam('postAction');
    const [linkCode] = hooks.useQueryParam('linkCode');
    const [state] = hooks.useQueryParam('state');

    useEffect(() => {
        if (linkCode) {
            let postAction: string | undefined = undefined;
            let app: domain.SsoLoginApplication | undefined = undefined;

            if (state) {
                try {
                    const decodedUiState = JSON.parse(decodeURIComponent(state));

                    postAction = decodedUiState.afterLoginRedirectUrl;
                    app = decodedUiState.app;
                } catch (error) {
                    Sentry.captureException(error);
                    Sentry.captureMessage(`Failed to decode params.state=${state}`);
                }
            }

            dispatch(
                verifyEmail({
                    app,
                    linkCode,
                    postAction,
                })
            );
        } else {
            dispatch(
                verifyEmail({
                    email,
                    code,
                    postAction,
                })
            );
        }
    }, [email, code, linkCode, state, postAction, dispatch]);

    return (
        <Flex direction='column' alignItems='center' spacing='24'>
            <LettersImage width={100} height={100} />

            <Text font='headline' fontSize='xsmall' fontWeight='medium'>
                {messages.title}
            </Text>

            <Progress shape='circle' />
        </Flex>
    );
});

Content.displayName = 'Content';
